package com.tixforgigs.common

import kotlin.Boolean
import kotlin.String

internal object CommonBuildKonfig {
  public val API_VERSION: String = "4.6.324"

  public val MATOMO_URL: String = "https://ping.company.tixforgigs.com/dev/ping"

  public val CLIENT_VERSION: String = "4.6.275-SNAPSHOT"

  public val BUILD_TIMESTAMP: String = "2026-04-28T10:13:39+0200"

  public val TEST: Boolean = false

  public val TEST_USER: String = ""

  public val TEST_PASS: String = ""

  public val TEST_GN: String = ""

  public val TEST_SN: String = ""

  public val TEST_DOB: String = ""

  public val TEST_IBAN: String = ""

  public val TEST_BIC: String = ""

  public val TEST_BANK: String = ""
}
